import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    "mobile:flex-col",
    "mobile:p-5",
    "mobile:pb-0",
    "mobile:items-center",
    // Tablet
    "tablet:flex-row",
    "tablet:p-10",
    "tablet:items-start",
    // All
    "flex",
    "justify-center",
    "gap-10"
);
export const locationItem = classNames(
    // Mobile
    "mobile:text-lg",
    "mobile:mb-10",
    "mobile:w-72",
    // Tablet
    "tablet:text-2xl",
    "tablet:mb-0",
    "tablet:w-auto",
    // All
    "flex",
    "flex-start",
    "justify-start"
);
export const icon = classNames("w-8", "h-8", "mr-2");
export const strong = classNames("font-medium");
